export const instructionVideoIds: string[] = [
  'kcA4dBBFYIk',
  'bdAfYha9Sy4',
  'up_7j12jXYg',
  'tcPn0H4zVnA',
  'Dc9oi4mRTus',
  '6Qbpv9BwNJs',
  'ssMoNg2U2WA',
  'B3JJ91sPm54',
  'FeyLWwS2E0Q',
  'eFDF_dF4qSE',
  'Fw82aApR7yk',
  'VCIw0Im-xl4',
  'qw-H1WnOtzs',
];

export const getYoutubeEmbedUrl = (videoId: string) =>
  `https://www.youtube.com/embed/${videoId}`;
